// Global form configuration for feature flags
export const GLOBAL_FORM_CONFIG = {
  enableValidation: false,
  enableCalculations: true, // Enable calculations
  enableDependencyProcessing: false,
  debugMode: true,
};
